import { StorageKeyEnum as r } from "../../const/StorageKeyEnum.js";
import { http as s } from "../http.js";
import n from "localforage";
import { AUTH_TOKEN_EXPIRE_TIME as i } from "../../const/Auth.js";
const p = "/api/v1/refresh_token", _ = async (e) => {
  const t = await s().post("/api/v1/login", e);
  if (t.code === 0) {
    const o = t.data?.access_token;
    console.log("accessToken: ", o);
    const a = t.data?.refresh_token;
    console.log("refreshToken: ", a);
    const c = Date.now() + i;
    await n.setItem(r.ADMIN_TOKEN, o), await n.setItem(r.ADMIN_REFRESH_TOKEN, a), await n.setItem(r.ADMIN_TOKEN_EXPIRE_TIME, c);
  }
  return t;
}, m = async () => {
  const e = await s().get(p);
  if (e.code === 0) {
    const t = e.data?.access_token, o = Date.now() + i;
    await n.setItem(r.ADMIN_TOKEN, t), await n.setItem(r.ADMIN_TOKEN_EXPIRE_TIME, o);
  }
  return e;
}, g = (e) => s().get("/api/v1/invite/info", { token: e }), v = (e, t, o = 6) => s().get("/api/v1/register/setup", { token: e, email: t, digits: o }), k = (e) => s().post("/api/v1/register/verify", e), N = (e = {}) => s().post("/api/v1/invite/create", e);
export {
  N as createInvite,
  g as getInviteInfo,
  _ as login,
  m as refreshAccessToken,
  p as refreshTokenUrl,
  v as setupTotp,
  k as verifyAndRegister
};
